import _ from 'lodash';
import { useEffect, useReducer } from 'react';
import Promise from 'bluebird';

function resolvePromise( promise ) {
  return typeof promise === 'function' ? Promise.try( promise ) : promise;
}

function reducer( state, action ) {
  switch ( action.type ) {
    case 'pending': return { state : 'pending' };
    case 'resolved': return { result : action.result, state : 'resolved' };
    case 'rejected': return { error : action.error, state : 'rejected' };
    /* istanbul ignore next */
    default: return state;
  }
}

export function usePromise( promise, inputs=[] ) {
  const [ data, dispatch ] = useReducer( reducer, { state : 'pending' } );

  useEffect( () => {
    // Eslint will warn that this assignment to `promise` will be lost
    // on each render, but that's what we want, because if the inputs
    // change and the promise was a function then we want to run it
    // again and start over.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    promise = resolvePromise( promise );
    if ( ! promise ) return;
    let cancelled = false;
    dispatch( { type : 'pending' } );
    promise.then( result => {
      return cancelled ? null : dispatch( { state : 'resolved', result } );
    } ).catch( error => {
      return cancelled ? null : dispatch( { state : 'rejected', error } );
    } );
    return () => cancelled = true;
  }, inputs );

  data.loading = ( data.state !== 'resolved' && data.state !== 'rejected' );

  return data;
}
